import { css } from "lit";


export const style = css`
	:host {
		width: 100%;
		height: 100%;
		position: relative;
	}

	:host([highlight]) {
		border: 1px dashed var(--og-accent-color);
		border-radius: var(--og-base-radius);
	}

	:host([transparent]) {
		background-color: transparent;
	}

	.container {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.body {
		flex: 1;
		height: 100%;
		position: relative;
		overflow: hidden;
	}

	.controls {
		flex: 0 0 20px;
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		height: 20px;
		z-index: 1000;
	}

	.controls.has-title {
		position: static;
	}

	.controls .title {
		flex: 1;
		text-align: center;
		padding-left: 5px;
		line-height: 20px;
	}

	.controls og-dropdown-menu {
		position: absolute;
		right: 0;
		top: 0;
		width: 30px;
		height: 20px;
	}
`;
